import { ResultPage } from './ResultPage';
import { SettingsPage } from './SettingsPage';

export {
ResultPage,
SettingsPage
}


/** WEBPACK FOOTER **
 ** ./Typescript/Pages/FreeRoundConfigurationImport/index.ts
 **/